import { createAction } from 'redux-actions'
import {
  RESET_MENUSCACHE,
  GET_COMMODITIES,
  GET_MENUS,
  GET_TAGS,
  SELECT_TAG,
  UPDATE_FORCE_REFRESH_MENU,
} from 'constants/actionType'
import menuApi from 'services/api/menu'
import categoryApi from 'services/api/category'
import * as _ from 'lodash'
import {
  getStorage,
  setStorage,
} from '../../store/localStorage'

const resetMenusCacheAction = createAction(RESET_MENUSCACHE)
const getCommoditiesAction = createAction(GET_COMMODITIES)
const getMenusAction = createAction(GET_MENUS)
const getTagsAction = createAction(GET_TAGS)
const selectTagAction = createAction(SELECT_TAG)
const updateForceRefreshMenuAction = createAction(UPDATE_FORCE_REFRESH_MENU)

// > get all comodities of this merchant by merchantId (state.merchant.id)
export const getCommodities = (merchantId) => async (dispatch, getState) => {
  try {
    // const categoryIds = getState().categories.map(c => c.id)
    const [comm, setmenus, sets] = await Promise.all([
      // Filter out subcategory commodities.
      // menuApi.getCommodities(merchantId).then(comm => {
      //   return comm.filter(commodity => _.includes(categoryIds, commodity.categoryId))
      // }),
      menuApi.getCommodities(merchantId), // > expecting an array of object
      menuApi.getSetmenus(merchantId),
      categoryApi.getSets(merchantId), // > expecting an array of object
    ])

    const firstStepKeys = sets.map(s => _.get(s.steps, '0.key', ''))
    const firstStepMenus = setmenus.filter(setmenu => firstStepKeys.includes(setmenu.step))
    const commodities = [...comm, ...firstStepMenus, ...sets]
    dispatch(getCommoditiesAction({ commodities }))
  } catch (error) {
    console.error('getCommodities error', error)
    return Promise.reject(error)
  }
}

// > reset menus cache after submit order.
export function resetMenusCache () {
  return (dispatch, getState) => {
    console.log('resetMenusCache')
    dispatch(resetMenusCacheAction())
  }
}

export function updateForceRefreshMenu (bool) {
  return (dispatch, getState) => {
    dispatch(updateForceRefreshMenuAction(bool))
  }
}

export const getMenus = (params) => async (dispatch, getState) => {
  const { merchantId, categoryId, tag, isSet, isTakeaway, datetime } = params
  const { menusCache } = getState()
  const key = menuApi.getListKey(categoryId, tag)
  const data = menusCache[key]

  // Try to use menuCache before fetch menu from server.
  // If forceRefreshMenu is true, fetch menu from server directory.
  if (!params.forceRefreshMenu && data) {
    dispatch(getMenusAction({
      categoryId,
      tag,
      menus: data,
    }))
    return Promise.resolve()
  }

  try {
    let results
    if (!isSet) {
      results = await menuApi.list(merchantId, categoryId, (categoryId ? null : tag), isTakeaway, datetime)
      if (!categoryId) {
        // if categoryId & tag is null, by default show items in 'promote' menu
        // append results from promoted set items
        const promotedSet = await menuApi.listPromotedSet(merchantId, isTakeaway, datetime).then(sets => {
          return sets.filter(set => !set.sold)
        })
        if (promotedSet.length) {
          results = [...results, ...promotedSet].sort((m1, m2) => {
            return m2.promotedWeight - m1.promotedWeight
          })
        }
      }
    } else {
      results = await menuApi.listSet(merchantId, categoryId, isTakeaway, datetime)
    }
    console.log('results', results)
    const menuoptions = getStorage('menuoptions') || {}
    results.map(menu => {
      const optionGroups = _.get(menu, 'options', [])
      if (optionGroups) {
        optionGroups.map(grp => {
          const options = _.get(grp, 'options', [])
          options.map(opt => {
            _.set(menuoptions, `${menu.id}|${opt.id}`, true)
          })
        })
      }
    })
    setStorage('menuoptions', menuoptions)
    dispatch(getMenusAction({
      categoryId,
      tag,
      menus: results,
    }))

    // Reset forceRefreshMenu to false.
    if (menusCache.forceRefreshMenu) {
      dispatch(updateForceRefreshMenu(false))
    }
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getTags = (merchantId, locale) => async (dispatch, getState) => {
  const { tags } = getState()
  if (tags) {
    dispatch(getTagsAction(tags))
    return Promise.resolve()
  }

  try {
    dispatch(getTagsAction(null))
    const tagList = await menuApi.listTags(merchantId, locale)
    dispatch(getTagsAction(tagList))
    return Promise.resolve()
  } catch (error) {
    return Promise.reject(error)
  }
}

export const selectTag = (tag) => (dispatch) => {
  dispatch(selectTagAction(tag))
}



// WEBPACK FOOTER //
// ./src/actions/components/menu.js